import { useAppContext } from '@/store'

export const useSession = () => {
  const app = useAppContext()
  return app.state.session
}
